// Funcionalidades ligadas no servidor (GET /config). Sem resposta, só a loja VIP fica desligada.
import { api } from "./api";

export interface Features {
  vipShop: boolean;
  globalChat: boolean;
  changelog: boolean;
}

let features: Features = { vipShop: false, globalChat: true, changelog: true };

export async function loadFeatures(): Promise<void> {
  try {
    features = { ...features, ...(await api.config()).features };
  } catch {
    /* API fora do ar: mantém o padrão */
  }
}

export function feature(name: keyof Features): boolean {
  return features[name];
}
